import { encrypt } from '../util/CryptoUtil'

export default function SetRoleUser(dispatch, role) {
    dispatch({ type: 'SET_ROLE', role_user: role });
    const roleEncrypted = encrypt(role);
    localStorage.setItem(process.env.REACT_APP_ROLEUSER, roleEncrypted);
}